import { CartLinesUpdateEvent } from '@shopify/events';

async function tcAdd(btn, items) {
  if (btn.dataset.busy) return;
  btn.dataset.busy = '1';
  const label = btn.innerHTML;
  btn.innerHTML = 'Ajout…';
  btn.disabled = true;
  const drawer = document.querySelector('#cart-drawer');
  const deferred = CartLinesUpdateEvent.createPromise();
  btn.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add',
    context: 'product',
    lines: items.map((i) => ({ merchandiseId: 'gid://shopify/ProductVariant/' + i.id, quantity: i.quantity })),
    promise: deferred.promise,
  }));
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: 'cart-drawer-section' }),
    }).then((r) => r.json());
    const cart = await fetch('/cart.js').then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { sections: res.sections, items: res.items, itemCount: items.length, source: 'tc-upsell', didError: !!res.status },
    });
    if (res.status) { btn.innerHTML = res.description || 'Indisponible'; return; }
    if (!drawer) { location.reload(); return; }
    if (!drawer.isOpen && typeof drawer.open === 'function') drawer.open();
    btn.innerHTML = 'Ajouté ✓';
  } catch (e) {
    deferred.reject(e);
    btn.innerHTML = label;
  } finally {
    setTimeout(() => { delete btn.dataset.busy; btn.disabled = false; if (btn.innerHTML === 'Ajouté ✓') btn.innerHTML = label; }, 1800);
  }
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-tc-add]');
  if (!btn) return;
  e.preventDefault();
  const wrap = btn.closest('[data-tc-item]') || btn.parentElement;
  const sel = wrap.querySelector('select[data-tc-variant]');
  const id = Number(sel ? sel.value : btn.dataset.variant);
  if (!id) { if (sel) { sel.focus(); sel.classList.add('tc-need'); } return; }
  tcAdd(btn, [{ id, quantity: 1 }]);
});